import React, { useState } from "react";
import MediaQuery from "react-responsive";
import ModalAnswer from "../ModalAnswer";
import Icon from "../../../components/icon";
import RenderModal from "../../../components/renderModal";
import { stripTags } from "../../../components/utils/strings";
import * as S from "./styles";
import { CouponBanner } from "../CouponBanner";
import moment from "moment";

export const Feedback = ({ feedback = [], pdfUrl, isRanking, slug, history, hasAttempt = true, couponUrl, couponCode, couponDiscount }) => {
  const [modalResolution, setModalResolution] = useState(false);
  const [index, setIndex] = useState(false);
  const [modalAnswers, setModalAnswers] = useState(false);

  const isCertificadoAvailable = slug === 'simulado-sos-2025-15-11-sabado' || slug === 'simulado-sos-2025-08-11-sabado';
  // const isCertificadoAvailable = true;
  const week = moment().isBefore('2025-11-10') ? 1 : 2;

  const handleGenerateCertificado = () => {
    const user = localStorage.getItem('certificateData');

    if (!user) {
      history.push(`/gerar-alta-hospitalar/${week}`);
    } else {
      history.push(`/gerar-alta-hospitalar/preview/${week}`);
    }
  };

  const handleModal = (index) => {
    console.log("i", index);
    setModalResolution(!modalResolution);
    setIndex(index);
  };

  const handleModalPrint = () => {
    setModalAnswers(!modalAnswers);
  };

  const canceleds = feedback.filter((it) => it.isCanceled).length;
  let corrects = feedback
    .filter((it) => !it.isCanceled)
    .filter((it) => it.isCorrect).length;
  corrects = isRanking ? corrects + canceleds : corrects;
  const incorrects = feedback
    .filter((it) => !it.isCanceled)
    .filter((it) => !it.isCorrect).length;
  const colSpanMobile = window.matchMedia("(max-width: 1023px)").matches
    ? "1"
    : "4";
  const isDarkMode = localStorage.getItem("isDarkMode") === "true";

  const mathFeedback = feedback
    .filter((it) => it.area === "5b2186ec9c5aa43084ff7d1c")
    .sort((a, b) => a.order - b.order);
  const restFeedback = feedback
    .filter((it) => it.area !== "5b2186ec9c5aa43084ff7d1c")
    .sort((a, b) => a.order - b.order);
  const completeFeedback = [...restFeedback, ...mathFeedback].sort(
    (a, b) => a.order - b.order
  );

  return (
    <>
      <S.Content>
        {isCertificadoAvailable && (
          <S.CertificateCard disabled={!isCertificadoAvailable}>
            <S.CertificateTitleWrapper>
              <S.CertificateEmoji>🎉</S.CertificateEmoji>
              <S.CertificateTitle disabled={!isCertificadoAvailable}>
                Acesse sua Alta Hospitalar!
              </S.CertificateTitle>
            </S.CertificateTitleWrapper>
            <S.CertificateSubtitle disabled={!isCertificadoAvailable}>
              Compartilhe e mostre que você está preparado!
            </S.CertificateSubtitle>
            <S.CertificateButton
              disabled={!isCertificadoAvailable}
              onClick={handleGenerateCertificado}
            >
              <Icon icon={"paper"} height={18} width={18}/>
              Acessar Alta Hospitalar
            </S.CertificateButton>
          </S.CertificateCard>
        )}

        <S.Header>
          <S.Left>Gabarito</S.Left>
        </S.Header>
        <S.Grid>
          <S.Table cellPadding="16">
            <S.Thead>
              <S.Tr isDarkMode={isDarkMode}>
                <S.Th question scope="col" colSpan={colSpanMobile} style={{ textAlign: 'left' }}>
                  Questão
                </S.Th>
                {hasAttempt && (
                  <S.Th small scope="col">
                    {" "}
                    Sua resposta{" "}
                  </S.Th>
                )}
                <S.Th small scope="col">
                  {" "}
                  Gabarito{" "}
                </S.Th>
                {hasAttempt && (
                  <MediaQuery query="(min-width: 1024px)">
                    <S.Th micro scope="col" />
                  </MediaQuery>
                )}
                <S.Th resolution scope="col">
                  <MediaQuery query="(min-width: 1024px)">Resolução</MediaQuery>
                </S.Th>
              </S.Tr>
            </S.Thead>

            <S.Tbody>
              {completeFeedback.map((it, index) => {
                const labelStatement = stripTags(it.questionText);
                const questionCanceled = isRanking ? it.isCanceled : false;

                return (
                  <S.Tr
                    isLast={index + 1 === feedback.length}
                    isDarkMode={isDarkMode}
                    key={`feedback-${index}`}
                  >
                    <S.Td question colSpan={colSpanMobile}>
                      <S.NumberQuestion questionCanceled={questionCanceled}>
                        {" "}
                        {index + 1}{" "}
                      </S.NumberQuestion>
                      {questionCanceled && (
                        <S.BadgeCanceled>Anulada</S.BadgeCanceled>
                      )}
                      <S.QuestionText questionCanceled={questionCanceled}>
                        {labelStatement.replace(/\\.*\\\)?/, "")}
                      </S.QuestionText>
                    </S.Td>
                    {hasAttempt && (
                      <S.Td questionCanceled={questionCanceled} bold>
                        {it.myAnswer}
                      </S.Td>
                    )}
                    <S.Td questionCanceled={questionCanceled} bold>
                      {it.correctLetter}
                    </S.Td>
                    {hasAttempt && (
                      <MediaQuery query="(min-width: 1024px)">
                        <S.Td correct={it.isCorrect}>
                          {!questionCanceled && (
                            <Icon
                              icon={it.isCorrect ? "circleCheck" : "circleWrong"}
                              height={16}
                              width={16}
                            />
                          )}
                        </S.Td>
                      </MediaQuery>
                    )}
                    <S.Td isLast={index + 1 === feedback.length}>
                      <S.Buttons onClick={() => handleModal(index)}>
                        VER
                      </S.Buttons>
                    </S.Td>
                  </S.Tr>
                );
              })}
            </S.Tbody>
          </S.Table>
        </S.Grid>

        {hasAttempt && (
          <S.Footer>
            <S.FooterRight>
              <S.Corrects>
                <Icon icon={"circleCheck"} height={16} width={16} />
                {corrects} ACERTOS
              </S.Corrects>
              <S.Incorrects>
                <Icon icon={"circleWrong"} height={16} width={16} />
                {incorrects} ERROS
              </S.Incorrects>
            </S.FooterRight>
          </S.Footer>
        )}

        {/* <S.FooterButtons>
          <S.ButtonLink href="/craques-enem">ESCOLHER UM NOVO SIMULADO</S.ButtonLink>
          <S.ButtonLink
            href="https://sos.aprovatotal.com.br/"
            target="_blank"
          >
            Acompanhe os próximos aulões ao vivo
            <Icon icon={"youtube"} height={17} width={23} />
          </S.ButtonLink>
        </S.FooterButtons> */}

        {modalResolution && (
          <RenderModal>
            <ModalAnswer
              toggleModalAnswer={handleModal}
              resolutionIndex={index}
              feedback={completeFeedback}
              feedbackQuestion={completeFeedback[index]}
            />
          </RenderModal>
        )}
      </S.Content>
      <CouponBanner
        couponUrl={couponUrl}
        couponCode={couponCode}
        couponDiscount={couponDiscount}
      />
    </>
  );
};
